import { useLocation } from 'react-router-dom';
import { useI18n } from '../../contexts/I18nContext';
import { SEO } from './SEO';
import { STATIC_PAGE_META, resolvePageKey } from '../../config/pageMeta';

// Applica title/description route-specifici alle pagine pubbliche senza <SEO> proprio.
// Le rotte non mappate (landing, auth, download, ...) non vengono toccate.
export function RouteMeta() {
  const { pathname } = useLocation();
  const { t } = useI18n();

  const key = resolvePageKey(pathname);
  const entry = key ? STATIC_PAGE_META[key] : undefined;
  if (!entry) return null;

  const title = t(entry.ns as never, entry.titleKey);
  if (!title) return null;
  const description = t(entry.ns as never, entry.descKey) || '';

  return <SEO title={title} description={description} path={`/${key}`} />;
}
